import { useContrastQuery } from '../../hooks/use-contrast-query'
import { Query } from '../../hooks/queries'
import {
  getRouteServers,
  RouteServersQueryArgs,
  RouteServersResponse
} from './api/route-servers'

export const useRouteServers = ({
  organizationUuid,
  applicationUuid,
  routeHash
}: RouteServersQueryArgs) => {
  return useContrastQuery<RouteServersQueryArgs, RouteServersResponse>(
    [Query.ROUTE_SERVERS, organizationUuid, applicationUuid, routeHash],
    getRouteServers,
    {
      organizationUuid,
      applicationUuid,
      routeHash
    }
  )
}
